import { Button, Responsive, TDeviceType, Theme, TTheme } from '@cian/ui-kit';
import * as styles from './styles.css';
import { NBSP } from 'shared/constants/symbols';
import { BUTTON_TEXT } from 'shared/constants/tracking';
import clsx from 'clsx';
import phoneImage from './assets/phone-image.png';
import { TButtonSize, TButtonTheme } from '@cian/ui-kit/button/types';

interface INewUserBonusBannerProps {
  device: TDeviceType;
  themeType: TTheme;
  btnProps: {
    color: TButtonTheme;
    size: TButtonSize;
    onClick: VoidFunction;
  };
}

export const NewUserBonusBanner: React.FC<INewUserBonusBannerProps> = ({ device, themeType, btnProps }) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      <Responsive phone>
        <img src={phoneImage} className={styles['img']} />
      </Responsive>
      <div className={styles['wrapper']}>
        <div className={styles['title']}>Впервые на{NBSP}Циан?</div>
        <div className={styles['description']}>Дарим 1 000 бонусов новым пользователям</div>
        <div className={styles['btn']}>
          <Theme theme={themeType}>
            <Button {...btnProps} fullWidth>
              {BUTTON_TEXT.SUBMIT_AD}
            </Button>
          </Theme>
        </div>
      </div>
    </div>
  );
};
